<template>
	<NoticeListPage page-type="hot" />
</template>

<script setup>
import NoticeListPage from '@/components/notice/NoticeListPage.vue';
</script>
